<template>
  <div class="glass-style-dialog">
    <div v-for="item in items" :key="item.id" class="item-container">
      <div :class="item.selected ? 'style-item style-item--selected' : 'style-item'" @click="selectItem(item)">
        <img :src="item.photo" />
        <p class="style-item--title">{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items() {
      return this.options?.map(option => ({
        ...option,
        name: option.sku,
        photo: window.GLASSON_CONFIG.STORAGE + option.product.model.photos.split(",")[0],
        selected: this.selectedOpt?.id === option.id
      }));
    },
    options() {
      return this.$store.state.options?.style;
    },
    selectedOpt() {
      return this.$store.state.selectedOpt.style;
    }
  },
  methods: {
    selectItem(item) {
      this.$emit("select-item", item);
    }
  }
};
</script>

<style lang="scss" scoped>
.glass-style-dialog {
  overflow: auto;
  white-space: nowrap;
  max-width: 100%;
  max-height: 140px;
  background: #ffffff;
  border: 2px solid #2f80ed;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 12px 0px;
  display: flex;
  flex-direction: row;

  .item-container {
    display: inline-block;

    .style-item {
      content: "";
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      width: 116px;
      height: 116px;
      padding: 12px;
      margin: 0px 12px;
      cursor: pointer;

      &:hover {
        border: 2px dashed rgba(249, 216, 2, 0.7);
        border-radius: 16px;
      }

      &--selected {
        border: 2px dashed rgba(249, 216, 2, 0.7);
        border-radius: 16px;
      }

      &--title {
        font-size: 16px;
      }

      p {
        margin: 0;
        user-select: none;
      }

      img {
        width: 100%;
      }
    }

    .active {
      border: 2px dashed #f9d802;
      border-radius: 16px;
    }
  }
}
</style>
